import * as React from "react"

interface MainProps {
  className?: string
}

export const Main: React.StatelessComponent<MainProps> = props => <main className="main" id="a11y-main">{props.children}</main>
